export const getFileNameAndExtension = (fileName: string, mimeType: string) => {
  const separatorIndex = fileName.lastIndexOf('.');

  if (separatorIndex < 0) {
    // no mime
    return [fileName, mimeType || ''];
  }

  return [
    fileName.slice(0, separatorIndex),
    mimeType || fileName.slice(separatorIndex + 1),
  ];
};
